import React, { HTMLAttributes } from 'react';

import { View } from '@uncinc/react-drupal-core';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import './style.scss';
import { ParagraphText } from '../../../types/uncinc_profile/paragraphs';

interface ParagraphArticleOverviewProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<ParagraphText>;
}

const ParagraphArticleOverview: React.FC<ParagraphArticleOverviewProps> = (props) => {
  const { entity } = props;

  const paragraph = entity.toJS();
  const uuid = paragraph.uuid[0].value;

  return (
    <div id={uuid} className="ParagraphText">
      <View
        classes="row"
        id="article"
        display="overview"
        storageType="url"
        withProvider
      />
    </div>
  );
};

export default ParagraphArticleOverview;
